import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatGiveawayTime, nextGiveawayAt } from './giveaway-time';

export default /*@__PURE__*/_defineComponent({
  __name: 'GiveawayTime',
  props: {
    at: {},
    compact: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const { t, locale } = useI18n();
// Prerendered HTML must not use the build machine's time zone.
const zone = ref<string>();
onMounted(() => {
  zone.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
});
const time = computed(() =>
  zone.value ? formatGiveawayTime(props.at || nextGiveawayAt(), locale.value, zone.value) : null,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(time.value ? _unref(t)(_ctx.compact ? 'giveaway.timingShort' : 'giveaway.timing', { time: time.value }) : _unref(t)('giveaway.timingFallback')), 1))
}
}

})